import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../component/Footer';
import Header from '../../component/Header';
import './Cartpage.css';
import axios from "../../helper/axios"
import { makeCartEmpty } from "../../action";
import { useDispatch } from "react-redux";
import { trackPurchase } from "../../helper/analyticsConsent";

const OrderSuccess = () => {
  const dispatch = useDispatch()
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const transId = params.get('transId');
  const [orderedId, setOrderedId] = useState();
  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (hasCalledRef.current) return;
    hasCalledRef.current = true;

    paymentStatusChange();
    getOrderDetails();
  }, []);

  const paymentStatusChange = async () => {
    const data = { transId: transId, status: "paid" };
    dispatch(makeCartEmpty(data));
    //await axios.post("/updatepaymentstatus", data);
  }

  const getOrderDetails = async () => {
    const data = { transId: transId };
    const res = await axios.post("/orderDetails", data);
    const orderIds = res.data.map(order => order.orderId).join(", ");
    setOrderedId(orderIds);

    // Tracking purchase event (only fires after cookie consent is accepted)
    try {
      const first = Array.isArray(res?.data) ? res.data[0] : null;
      const items = first?.productList || [];

      // Prefer overall totalPrice if it exists; fallback to sum of grandTotal; fallback to sum of sale_price * qty
      const totalFromTotalPrice = Number(items?.[0]?.totalPrice || 0);
      const totalFromGrandTotal = Array.isArray(items)
        ? items.reduce((acc, it) => acc + Number(it?.grandTotal || 0), 0)
        : 0;
      const totalFromLineItems = Array.isArray(items)
        ? items.reduce((acc, it) => acc + (Number(it?.sale_price || it?.regular_price || 0) * Number(it?.quantity || 1)), 0)
        : 0;

      const value = totalFromTotalPrice || totalFromGrandTotal || totalFromLineItems || 0;

      trackPurchase({
        transactionId: transId,
        value,
        items,
      });
    } catch (e) {
      // ignore tracking errors
    }
  }

  return (
    <>
      <Header />
      <div className="order-success-page">
        <div className="card-success-simple">
          <div className='success-simple'>
            <div className="checkmark-simple">
              <i>✓</i>
            </div>
            <h4>Faleminderit për besimin tuaj!</h4>
            <h3>Porosia juaj është realizuar</h3>
            <p className="order-number">Numri i porosisë: #{orderedId}</p>
            <p>Ju do të pranoni të gjitha detajet e porosisë përmes email</p>
            <p>Nëse nuk e shihni email-in, ju lutem kontrolloni folderin SPAM</p>
            <button className='btn-simple'>
              <a href="/">KTHEHU NË BALLINË</a>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default OrderSuccess;